import { useMemo } from 'react';
import {
	filterKeys,
	getEntityById,
	nullSafeGetOrElse,
	parseFilterValueToAdvancedFilters,
} from '../../utils/DataAccessUtils';
import { SORTING_PROPS } from '../../utils/DataConstants';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { withUserType } from '../withUserType';
import { getWorkOrderArchivalKey } from '../../utils/WorkOrderUtils';

function WorkOrderFiltersWrapper({ children, currentUser, location, view, defaultView }) {
	const selectedView = view || defaultView;
	const { defaultFilters, defaultSorting } = useMemo(() => {
		if (view || (location && !Boolean(location.search))) {
			const defaultFilterView = nullSafeGetOrElse('filterValue', selectedView, {});
			const parsedView = parseFilterValueToAdvancedFilters(defaultFilterView);
			const sorting = filterKeys(parsedView, SORTING_PROPS, true);
			return {
				defaultFilters: filterKeys(
					parsedView,
					[...SORTING_PROPS, getWorkOrderArchivalKey(currentUser)],
					false
				),
				// Only forward a saved sort when one exists; an empty object is truthy and
				// would clobber the table's DEFAULT_SORTER fallback in parseURL.
				defaultSorting: sorting.sort_by ? sorting : undefined,
			};
		}
		return { defaultFilters: undefined, defaultSorting: undefined };
	}, [selectedView, location, view, currentUser]);

	return children(defaultFilters, defaultSorting); // Pass filters and sorting to child as render prop
}

const mapStateToProps = (state, ownProps) => ({
	currentUser: state.session.currentUser,
	defaultView: state.session.defaultView,
});

const mapDispatchToProps = (dispatch, ownProps) => ({});
export default withUserType(
	withRouter(connect(mapStateToProps, mapDispatchToProps)(WorkOrderFiltersWrapper))
);
